export function toCSSSize(prop?: string | number): string | undefined {
  if (prop === undefined) return;
  return typeof prop === 'number' ? `${prop}px` : `${prop}`;
}
